'use client';

import { Button } from '@/components/ui/button';
import { HomeIcon } from 'lucide-react';
import Link from 'next/link';
import { type ReactElement, useEffect } from 'react';

export default function Error({
  error,
}: {
  readonly error: Error & { readonly digest?: string };
}): ReactElement {
  useEffect(() => console.error(error), [error]);

  return (
    <div className="w-full h-screen p-4 flex items-center justify-center flex-col gap-5">
      <div className="flex flex-col items-center justify-center gap-2">
        <h1 className="font-bold text-xl text-center">Something went wrong!</h1>
        <p className="text-base font-light text-center max-w-3xl">
          An error occurred while processing your request. Detailed error information has been
          logged for review. We apologize for the inconvenience.
        </p>
      </div>
      <div>
        <Link href="/" target="_self">
          <Button className="flex items-center justify-center gap-2">
            <HomeIcon width={20} height={20} />
            <p>Main page</p>
          </Button>
        </Link>
      </div>
      <p className="text-xs font-light text-center opacity-80 max-h-40 overflow-y-auto">
        {String(error.message)}
      </p>
    </div>
  );
}
